export const AUTH_TEST_IDS = {
  PAGE: 'auth-login-page',
  LEFT_PANEL: 'auth-login-left-panel',
  RIGHT_PANEL: 'auth-login-right-panel',
  MOBILE_CARD: 'auth-login-mobile-card',
  DESKTOP_CARD: 'auth-login-desktop-card',
  SIGN_IN_BTN_MOBILE: 'auth-login-sign-in-btn-mobile',
  SIGN_IN_BTN_DESKTOP: 'auth-login-sign-in-btn-desktop',
} as const;
